// extracted by mini-css-extract-plugin
export default {"labelContainer":"_6Iqec","label":"f69Da","labelIcon":"AGCRS","categorySelect":"L7hyr"};